import { Hex, } from "@keep-network/tbtc-v2.ts";
export default class OrangeKitTbtcRedeemerProxy {
    #contracts;
    #orangeKitSdk;
    #account;
    #bitcoinProvider;
    #sharesAmount;
    #dataBuiltStepCallback;
    #onSignMessageStepCallback;
    #messageSignedStepCallback;
    constructor(contracts, orangeKitSdk, account, bitcoinProvider, sharesAmount, dataBuiltStepCallback, onSignMessageStepCallback, messageSignedStepCallback) {
        this.#contracts = contracts;
        this.#orangeKitSdk = orangeKitSdk;
        this.#account = account;
        this.#bitcoinProvider = bitcoinProvider;
        this.#sharesAmount = sharesAmount;
        this.#dataBuiltStepCallback = dataBuiltStepCallback;
        this.#onSignMessageStepCallback = onSignMessageStepCallback;
        this.#messageSignedStepCallback = messageSignedStepCallback;
    }
    redeemerAddress() {
        return this.#account.ethereumAddress;
    }
    async requestRedemption(redemptionData) {
        const safeTxData = this.#contracts.stBTC.encodeApproveAndCallFunctionData(this.#contracts.bitcoinRedeemer.getChainIdentifier(), this.#sharesAmount, redemptionData);
        await this.#dataBuiltStepCallback?.(safeTxData);
        const transactionHash = await this.#orangeKitSdk.sendTransaction(`0x${this.#contracts.stBTC.getChainIdentifier().identifierHex}`, "0x0", safeTxData.toPrefixedString(), this.#account.bitcoinAddress, this.#account.publicKey, async (message, txData) => {
            await this.#onSignMessageStepCallback?.(message);
            const signedMessage = await (this.#bitcoinProvider.signWithdrawMessage?.(message, txData) ??
                (await this.#bitcoinProvider.signMessage(message)));
            await this.#messageSignedStepCallback?.(signedMessage);
            return signedMessage;
        });
        return Hex.from(transactionHash);
    }
}
//# sourceMappingURL=redeemer-proxy.js.map